<template lang="pug">
#vacuum_forming
  section.banner.position-relative
    div.picture
        img.img-fluid.big(src="img/banner/banner_vacuum_forming.jpg" alt="banner-certificate")
        img.img-fluid.small(src="img/banner/banner_vacuum_forming_mobile.jpg" alt="banner-certificate")
    div.mask_banner
    div.breadcrumb_block
      b-container
        b-breadcrumb(:items="breadcrumb_items")
    div.banner_h1
      h1 Vacuum Molding
  b-container.py-0.py-lg-5.slogan
    p.text-center.font-weight-bolder.py-5 A flat plastic sheet is formed into a three-dimensional curved package by blister equipment which use high temperature and molds, so that consumers can directly see the product and protect it.
  section#product_profile
    b-row.menu
      b-col.text-center.position-relative(:class="{ active: p_show[0].show }" @click='change("PVC")') PVC
      b-col.text-center(:class="{ active: p_show[1].show }" @click='change("APET")') APET
    b-container.pt-md-4
      b-row#pvc_detail.detail.pb-5.py-md-5(:class="{ active: p_show[0].show }" @click='change("PVC")') 
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span Product application description
            p 1.The advantages of this product are excellent vacuum formability, impact resistance and chemical resistance, and can be used to make packaging materials for various commodities such as stationery, toys, tools, and gifts.
              br
              |2.This product can provide products of suitable specifications with different heat shrinkage according to the requirements of the customer's machine.
          div
            h3 
              span Product Features
            ol
              li(v-for="item in p_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span Product Information
            ol
              li(v-for="item in p_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
      b-row#apet_detail.detail.pb-5.py-md-5(:class="{ active: p_show[1].show }" @click='change("APET")') 
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span Product application description
            p The advantages of this product are excellent transparency, good vacuum formability and chemical resistance, and can be used to make packaging materials for various commodities such as hardware, tools, toys, stationery and gifts.
          div
            h3 
              span Product Features
            ol
              li(v-for="item in a_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span Product Information
            ol
              li(v-for="item in a_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
  section#specification.py-5(:class="{ active: p_show[0].show }" @click='change("PVC")') 
    div.mask
    h2.text-center 
      span PVC Specification
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_pvc").swiper_pvc.swiper_product_col_3
        swiper-slide(v-for="item in p_specification" :key="item.id")
          ul
            li 
              span {{ item.name }}
            li 
              span {{ item.feature }}
            li 
              span {{ item.outward }}
            li 
              span(v-html="item.thickness")
            li 
              span(v-html="item.proportion")
            li 
              span(v-html="item.pull")
            li 
              span(v-html="item.elongation")
            li 
              span(v-html="item.heating")
            li 
              span(v-html="item.vcm")
        <div class="swiper-pagination" slot="pagination"></div>
  section#specification.py-5(:class="{ active: p_show[1].show }" @click='change("APET")') 
    div.mask
    h2.text-center 
      span  APET Specification
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_apet").swiper_apet.swiper_product_col_4
        swiper-slide(v-for="item in a_specification" :key="item.id")
          ul
              li 
                span {{ item.name }}
              li 
                span {{ item.feature }}
              li 
                span {{ item.outward }}
              li 
                span(v-html="item.thickness")
              li 
                span(v-html="item.proportion")
              li 
                span(v-html="item.transmittance")
              li 
                span(v-html="item.gloss")
              li 
                span(v-html="item.mist")
        <div class="swiper-pagination" slot="pagination"></div>
  section#others.py-5 
    b-container
      h3 Others
      swiper.swiper.py-5(:options="swiperOption")
        swiper-slide(v-for="item in swiperdata" :key="item.id")
          div
            router-link(:to="item.href_link")
              div
                b-img.w-100(:src="item.url" fluid)
                h5 {{item.name}}
              p.py-4 {{item.text}}
              svg.o_arrow_r(viewbox="0 0 50 30")
                line(x1=0 y1=20 x2=45 y2=20)
                line(x1=45 y1=20 x2=31 y2=8)
        div.swiper-pagination(slot="pagination")
        div.swiper-button-prev(slot="button-prev")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75) rotate(180deg)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        div.swiper-button-next(slot="button-next")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        

</template>
<script>
export default {
    metaInfo: {
        title: 'PVC / APET Vacuum Molding-NAN YA RIGID FILM',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'The advantages of this product are excellent vacuum formability, impact resistance and chemical resistance, and can be used to make packaging materials for various commodities such as stationery, toys, tools, and gifts. There are VVVG(normal mold), VVVD(Deep mold), etc.The advantages of this product are excellent transparency, good vacuum formability and chemical resistance, and can be used to make packaging materials for various commodities such as hardware, tools, toys, stationery and gifts. There are AVVG(normal mold), AVVD(Deep mold), etc.' },
            { name: 'Keywords', content: 'Nan Ya Plastics, Rigid Film, PVC, APET, Vacuum Molding, Deep Mold' },
            { name: 'og:title', content: 'PVC / APET Vacuum Molding-NAN YA RIGID FILM' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com/' },
            { name: 'og:description', content: 'The advantages of this product are excellent vacuum formability, impact resistance and chemical resistance, and can be used to make packaging materials for various commodities such as stationery, toys, tools, and gifts. There are VVVG(normal mold), VVVD(Deep mold), etc.The advantages of this product are excellent transparency, good vacuum formability and chemical resistance, and can be used to make packaging materials for various commodities such as hardware, tools, toys, stationery and gifts. There are AVVG(normal mold), AVVD(Deep mold), etc.' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com/img/OGimage.jpg' },
        ],
    },
  data() {
      return {
        breadcrumb_items: [
          {
            text: 'Home',
            to: { name: 'App' }
          },
          {
            text: 'Vacuum Molding',
            active: true
          }
        ],
        swiperOption_product_img: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        product_img_data: [
          { 
            id: '1',
            img_src: 'img/processing_Desktop/vacuum_forming_img_01.jpg',
            img_alt: 'Nan Ya Rigid PVC and APET have excellent vacuum formability, impact resistance and chemical resistance, and can be used as packaging materials for various commodities.' },
          { 
            id: '2',
            img_src: 'img/processing_Desktop/vacuum_forming_img_02.jpg',
            img_alt: 'Nan Ya Rigid PVC and APET have excellent vacuum formability, impact resistance and chemical resistance, and can be used as packaging materials for various commodities.' },
          { 
            id: '3',
            img_src: 'img/processing_Desktop/vacuum_forming_img_03.jpg',
            img_alt: 'Nan Ya Rigid PVC and APET have excellent vacuum formability, impact resistance and chemical resistance, and can be used as packaging materials for various commodities.' }
        ],
        p_show: [
          {show: true},
          {show: false}
        ],
        p_feature: [
          { message: 'Comply with EU REACH and ROHS regulations.' },
          { message: 'Good vacuum formability.' },
          { message: 'Good resistance to chemicals.' },
          { message: 'According to customer needs, products such as antistatic, anti-ultraviolet and high impact resistance can be produced.' }
        ],
        p_use: [
          { message: 'Customized items: tanning, corona, cold resistance, temperature resistance, weather resistance, flame resistance, antistatic and anti-fog, etc.' },
          { message: 'Inspection specifications: ASTM D-1593, ASTM D-792, JIS-K6734, etc.' }
        ],
        a_feature: [
          { message: 'Good transparency.' },
          { message: 'Good vacuum formability.' },
          { message: 'Resistance to chemicals.' }
        ],
        a_use: [
          { message: 'Customized items: tanning, corona, cold resistance, anti-static, anti-fog, high frequency, etc.' },
          { message: 'Inspection specifications: ASTM D-1593, ASTM D-792, ASTM D-1003 and ASTM D-523, etc.' }
        ],
        p_specification: [
          { 
            id: '1',
            name: 'VVVG(Normal Mold)',
            feature: 'Features:  Good formability, impact resistance, corrosion resistance',
            outward: 'Appearance: Transparent, colored, shiny, matte',
            thickness: 'Thickness<sub>(mm)</sub>：0.25',
            proportion: 'S.G.<sub>(g/cm3)</sub>：1.35±3%',
            pull: 'Tensile strength<sub>(kg/cm2)</sub>:<br/><span class="pl-5">MD>450/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub>：<br/><span class="pl-5">MD>135/CD>90</span>',
            heating: 'Heat Shrinkage<sub>(%,150°CX10min)</sub>：<br/><span class="pl-5">MD-6~-11/CD<1</span>',
            vcm: 'VCM<sub>(ppm)</sub>：Unregulated' },
          { 
            id: '2',
            name: 'VVVD(Deep Mold)',
            feature: 'Features: Excellent ductility, good formability',
            outward: 'Appearance: Transparent, colored, shiny, matte',
            thickness: 'Thickness<sub>(mm)</sub> ：0.35',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.35±3%',
            pull: 'Tensile strength<sub>(kg/cm2)</sub>：<br/><span class="pl-5">MD>450/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub> ：<br/><span class="pl-5">MD>135/CD>90</span>',
            heating: 'Heat Shrinkage<sub>(%,150°CX10min)</sub>：<br/><span class="pl-5">MD-5.5~-11/CD<1</span>',
            vcm: 'VCM(ppm)</sub>：Unregulated' },
          { 
            id: '3',
            name: 'VVVS(S Garde)',
            feature: 'Features: Easy blanking, impact resistance, corrosion resistance',
            outward: 'Appearance: Transparent, colored, shiny, matte',
            thickness: 'Thickness<sub>(mm)</sub> ：0.25',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.35±3%',
            pull: 'Tensile strength<sub>(kg/cm2)</sub>：<br/> <span class="pl-5">MD>450/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub>：<br/> <span class="pl-5">MD>135/CD>90</span>',
            heating: 'Heat Shrinkage<sub>(%,150°CX10min)</sub>：<br/> <span class="pl-5">MD-4.5~-13/CD<3.5</span>',
            vcm: 'VCM<sub>(ppm)</sub>：Unregulated' }
        ],
        a_specification: [
          { 
            id: '1',
            name: 'AVVB(Recycle Grade)',
            feature: 'Features: Good formability',
            outward: 'Appearance: Transparent, colored',
            thickness: 'Thickness<sub>(mm)</sub>：0.30  ',
            proportion: 'S.G.<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: 'VLT<sub>(Transparent Product,%)</sub>:<br/><span class="pl-5">82～92</span>',
            gloss: 'Gloss<sub>(Transparent Product)</sub>：<br/><span class="pl-5">140～165</span>',
            mist: 'HAZE<sub>(%)</sub>：<br/><span class="pl-5">1.0～6.0</span>'},
          { 
            id: '2',
            name: 'AVVG(Normal Mold)',
            feature: 'Features: Good transparency, good formability',
            outward: 'Appearance: Transparent, colored',
            thickness: 'Thickness<sub>(mm)</sub> ：0.40  ',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.34±0.01',
            transmittance: 'VLT<sub>(Transparent Product,%)</sub>：<br/><span class="pl-5">88～92</span>',
            gloss: 'Gloss<sub>(Transparent Product)</sub> ：<br/><span class="pl-5">158～168</span>',
            mist: 'HAZE<sub>(%)</sub>：<br/><span class="pl-5">≦3.0</span>' },
          { 
            id: '3',
            name: 'AVVD(Deep Mold)',
            feature: 'Features: Good transparency, good ductility during molding, good heat resistance',
            outward: 'Appearance: Transparent, colored',
            thickness: 'Thickness<sub>(mm)</sub> ：0.50 ',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.34±0.01',
            transmittance: 'VLT<sub>(Transparent Product,%)</sub>：<br/> <span class="pl-5">88～92</span>',
            gloss: 'Gloss<sub>(Transparent Product)</sub>：<br/> <span class="pl-5">158～168</span>',
            mist: 'HAZE<sub>(%)</sub>：<br/> <span class="pl-5">≦3.0</span>'},
          { 
            id: '4',
            name: 'AVVZ(Economic Grade)',
            feature: 'Features: Good transparency, good formability',
            outward: 'Appearance: Transparent, colored',
            thickness: 'Thickness<sub>(mm)</sub> ：0.40',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.34±0.01',
            transmittance: 'VLT<sub>(Transparent Product,%)</sub>：<br/> <span class="pl-5">88～92</span>',
            gloss: 'Gloss<sub>(Transparent Product)</sub>：<br/> <span class="pl-5">155～165</span>',
            mist: 'HAZE<sub>(%)</sub>：<br/> <span class="pl-5">≦3.5</span>'}
        ],
        swiperOption_pvc: {
          slidesPerView: 3,
          spaceBetween: 30,
          breakpoints: {
            1170: {
              spaceBetween: 30,
              slidesPerView: 'auto',
            },
            991: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption_apet: {
          slidesPerView: 4,
          spaceBetween: 30,
          breakpoints: {
            1550: {
              spaceBetween: 30,
              slidesPerView: 'auto',
            },
            991: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 51,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            767: {
              slidesPerView: 1,
              spaceBetween: 50
            }
          }
        },
        swiperdata: [
          {
            id:'2',
            name:'Fold Molding',
            text:'The semi-finished product of the box sheet that has been processed by printing, glazing, die-cutting, etc., is glued, folded, and glued according to the molding requirements of the box body to make a box body that can be used for packaging.',
            url:'./img/processing_Desktop/other_pic_pro_2.jpg',
            href_link: 'folding_forming'
          },
          {
            id:'3',
            name:'Heat Sealing',
            text:'Dielectric heat sealing for high frenquency heat sealing application.target as plastics staged between high electrodes sheet. Subject be fusioned and heat sealing with suitable temperature.',
            url:'./img/processing_Desktop/other_pic_pro_3.jpg',
            href_link: 'heat_seal'
          },
          {
            id:'4',
            name:'Printing',
            text:'On a continuous substrate, products made through processes such as printing, coating, laminating or pressing for majority of Printing process',
            url:'./img/processing_Desktop/other_pic_pro_4.jpg',
            href_link: 'print'
          },
          {
            id:'5',
            name:'Metalize',
            text:'Under vacuum conditions, a metal element is deposited on the surface  by steam or sputtering. In this way, a very thin coating on surface can be obtained, and it has the outstanding advantages of fast speed and good adhesion.',
            url:'./img/processing_Desktop/other_pic_pro_5.jpg',
            href_link: 'plating'
          }
        ]
      }
    },
  methods: {
    change:function(item) {
      if(item === 'PVC'){
        this.p_show[0].show = true
        this.p_show[1].show = false
      }
      else{
        this.p_show[1].show = true
        this.p_show[0].show = false
      }
      // for(let i in this.p_show){
      //   this.p_show[i].show = !this.p_show[i].show
      // }
      // this.p_show[0].show = false
      // this.p_show[1].show = true
      // this.p_show = !this.p_show
      // for(let i=0; i<this.p_show.length; i++){
      //   this.p_show[i] = !this.p_show[i]
      //   console.log(i)
      // }
      // console.log(this.p_show[1] + "," + this.p_show[0])
      }
      // if(event){
      //   this.p_show[0] = true
      //   this.p_show[1] = true
      //   console.log(this.p_show[1])}
    // }
  },
}
</script>
<style lang="sass">
@import '@/css/product.sass'
#vacuum_forming
  #specification
    background-image: url(../assets/bg/bg_vacuum_forming.jpg)


</style>
